module.exports = __webpack_public_path__ + "static/media/logo_publicbank.9a64373c.svg";